import { Link } from 'react-router-dom';
import { RadiologyLiveIcon } from '@/components/icons/ProductIcons';

export function Footer() {
  return (
    <footer className="border-t border-border/30 bg-card/50 scroll-snap-align-start">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo + copyright */}
          <div className="flex items-center gap-3">
            <RadiologyLiveIcon size={24} />
            <span className="text-sm">
              &copy; {new Date().getFullYear()} <span className="text-muted-foreground">RadiologyLive.ai</span>
            </span>
          </div>

          {/* Security badges */}
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span>Security-First Architecture</span>
            <span>HIPAA-Aligned Workflows</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms
            </Link>
            <Link to="/hipaa" className="hover:text-foreground transition-colors">
              HIPAA
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
